import CurrencyInput from "@/components/shared/CurrencyInput";

const AmountInput = ({ value, onChange, placeholder = "0", dataTestId }) => (
  <CurrencyInput
    value={value}
    onChange={onChange}
    className="amount-input"
    placeholder={placeholder}
    data-testid={dataTestId}
  />
);

export default AmountInput;
